import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { MyCeRequests } from '../my-ce-requests/my-ce-requests';
import { MyCeRequestsAssigned } from '../my-ce-requests-assigned/my-ce-requests-assigned';
import { CurrentUserService } from '../../services/current-user.service';

@Component({
  selector: 'app-requests-home',
  standalone: true,
  imports: [MyCeRequests, MyCeRequestsAssigned],
  template: `
    @if (isLoading()) {
      <div class="requests-home-loading">Loading...</div>
    } @else if (showAssigned()) {
      <app-my-ce-requests-assigned />
    } @else {
      <app-my-ce-requests />
    }
  `,
  styles: [`
    :host {
      display: block;
    }

    .requests-home-loading {
      padding: 2rem 1rem;
      color: #6b7280;
      font-size: 0.95rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestsHomeComponent {
  private readonly currentUserService = inject(CurrentUserService);

  protected readonly isLoading = signal(true);
  protected readonly showAssigned = signal(false);

  constructor() {
    void this.initialize();
  }

  private async initialize(): Promise<void> {
    await this.currentUserService.load();
    this.showAssigned.set(this.currentUserService.hasAnyRole(['ce_engineer']));
    this.isLoading.set(false);
  }
}